import { render } from "./AccountDataChangesSucceeded.vue?vue&type=template&id=07b129a1"
import script from "./AccountDataChangesSucceeded.vue?vue&type=script&lang=js"
export * from "./AccountDataChangesSucceeded.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__